import { render } from "./ExtragasHome.vue?vue&type=template&id=735ecb66&scoped=true"
import script from "./ExtragasHome.vue?vue&type=script&lang=js"
export * from "./ExtragasHome.vue?vue&type=script&lang=js"

import "./ExtragasHome.vue?vue&type=style&index=0&id=735ecb66&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735ecb66"]])

export default __exports__